import {
  IconHome,
  IconBulb,
  IconTarget,
  IconId,
  IconTools,
  IconTicket,
  IconCalendarEvent,
  IconCalendar,
  IconFolder,
  IconHelp,
  IconUsers,
  IconSitemap,
  IconUserSearch,
  IconCertificate,
  IconDeviceGamepad2
} from '@tabler/icons-react';

// Custom image URLs for specific trackers
const customImageMappings = {
  "4x4 Tracker": "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/4x4logo.png?alt=media&token=4867ff8e-efdd-4933-805d-01f193837337",
  "Production Tracker": "https://firebasestorage.googleapis.com/v0/b/wealthbuilders-crm-9c323.firebasestorage.app/o/ChatGPT%20Image%20Sep%2014%2C%202025%2C%2010_07_20%20PM.png?alt=media&token=8bcac8b2-de4a-4e19-83c6-f3beb8d82362"
};

// Icon and color mappings
export const iconMappings = {
  // Top level items
  "Home": { icon: IconHome, color: "#FFD700" }, // Gold
  "Insight Center": { icon: IconBulb, color: "#1E90FF" }, // Blue
  "Training Center": { icon: IconTarget, color: "#32CD32" }, // Green
  "Licensing": { icon: IconId, color: "#1E90FF" }, // Blue
  "10 Systematic Tools": { icon: IconTools, color: "#1E90FF" }, // Blue
  "Big Event": { icon: IconTicket, color: "#FFA500" }, // Orange
  "Training Schedule": { icon: IconCalendarEvent, color: "#32CD32" }, // Green
  "Calendar": { icon: IconCalendar, color: "#1E90FF" }, // Blue
  "File Vault": { icon: IconFolder, color: "#C0C0C0" }, // Silver
  "Help Desk": { icon: IconHelp, color: "#F4A7B9" }, // Rose
  "Onboarding Game": { icon: IconDeviceGamepad2, color: "#FF4500" }, // Red
  "Admin": { icon: IconId, color: "#FFD700" }, // Gold
  
  // My Team group
  "My Team": { icon: IconUsers, color: "#F4A7B9" }, // Rose
  "Org Chart": { icon: IconSitemap, color: "#F4A7B9" }, // Rose
  "Prospect Tracker": { icon: IconUserSearch, color: "#1E90FF" }, // Blue
  "Licensing Tracker": { icon: IconCertificate, color: "#F5F5F5" }, // Grey/White
  "Associate Tracker": { icon: IconUsers, color: "#F4A7B9" }, // Rose
};

export const getIcon = (itemName, props = {}) => {
  // Check if this item has a custom image
  const customImage = customImageMappings[itemName];
  
  if (customImage) {
    return (
      <img 
        src={customImage} 
        alt={itemName}
        style={{
          width: props.size || 20,
          height: props.size || 20,
          objectFit: 'contain'
        }}
        className="modern-nav-icon-img"
      />
    );
  }
  
  // Otherwise use Tabler icon with color
  const item = iconMappings[itemName];  // Get the item from the mapping
  if (!item) {
    // If the item doesn't exist in the iconMappings, return a default icon
    return <IconHome {...props} />; // Fallback to Home icon as default
  }

  const { icon: IconComponent, color } = item;  // Destructure the icon and color

  return (
    <IconComponent 
      {...props} 
      style={{ color: color }} // Apply the color here
    />
  );
};
